import koLocale from 'element-ui/lib/locale/lang/ko';
const ko = {
  tIndex: '대시보드',
  tNotification: '알림',
  tCarouselManagement: '메인 배너 관리',
  tCarouselDetail: '메인 배너 상세',
  tCarouselEdit: '메인 배너 수정',
  tMemberManagement: '회원 관리',
  tMemberList: '회원 리스트',
  tActiveMemberList: "활동 회원",
  tWithdrawMemberList: "탈퇴 회원",
  tMemberDetail: '회원 상세',
  tMemberAttendance: '미션 제출 내역',
  tMemberComment: '댓글  내역',
  tMemberDiscuss: '클러버 톡  내역',
  tMemberDisable: '사용금지 회원',
  tMemberDel: '탈퇴한 회원',
  tDormant: '휴면회원',
  tSend: '휴면 알림 기록 리스트',
  tReadManagement: '독서모임 관리',
  tReadList: '독서모임 리스트',
  tReadDetail: '독서모임 상세',
  tReadUserList: '독서모임 신청자 리스트',
  tEditRead: '독서모임 수정',
  tReadNoticeList: '모임 공지사항 리스트',
  tEditReadNotice: '공지사항 수정',
  tReadTaskList: '모임 미션 리스트',
  tEditReadTask: '미션 수정',
  tReadCommentList: '모임 댓글 리스트',
  tEditReadComment: '모임 댓글 수정',
  tAttendanceList: '미션 제출 리스트',
  tComment: '댓글 리스트',
  tReadTopicList: '모임 클러버 톡 리스트',
  tSerialManagement: '사유(뉴스레터) 관리',
  tSerialList: '작품 리스트',
  tSerialDetail: '작품 상세',
  tEditSerial: '작품 수정',
  tChapterList: '연재 리스트',
  tEditChapter: '연재 수정',
  tActivityManagement: '이벤트 관리',
  tActivityList: '이벤트 리스트',
  tEditActivity: '이벤트 수정',
  tActivityDetail: '이벤트 상세',
  tActivityUserList: '이벤트 신청자 리스트',
  tOrderManagement: '신청 관리',
  tOrderList: '주문리스트',
  tOrderDetail: '주문내역',
  tCouponManagement: '쿠폰 관리',
  tCouponList: '쿠폰 리스트',
  tEditCoupon: '쿠폰 수정',
  tSetMember: '쿠폰 대상 회원 설정',
  tCouponUseList: '쿠폰 사용현황 리스트',
  tServiceManagement: '서비스 관리',
  tServiceIntroduce: '서비스 소개',
  tServiceCommentList: '후기 리스트',
  tEditComment: '후기 수정',
  tServiceCenter: '고객센터',
  tNotice: '공지사항 리스트',
  tEditNotice: '공지사항 수정',
  tFAQ: '자주 묻는 질문',
  tEditFAQ: '자주 묻는 질문 수정',
  tQA: '1:1 문의',
  tEditQA: '답변 작성',
  tQADetail: '1:1 문의 상세',
  tSetting: '서비스 약관 관리',
  tSettingList: '서비스 약관 리스트',
  tSettingEdit: '서비스 약관 수정',
  tAccountManagement: '계정 관리',
  tIP: 'IP관리',
  tLog: '관리자로그 관리',
  tEdit: '수정',
  tDetail: '상세',
  notification: {
    sendNotification: '알림 발송',
    send: '발송',
    title: '제목',
    msg: '내용',
    create_time: '발송 시간',
  },
  carouselManagement: {
    title: '제목',
    create_time: '등록시간',
    update_time: '업데이트 시간',
    image: '이미지',
    h5_image: '모바일 이미지',
    order: '정렬 순',
    link: '이동 링크',
    h5_link: '모바일 이동 링크',
    active: '공개 여부',
    active0: '비공개',
    active1: '공개',
    sureDeleteCarousel: '정말 삭제하시겠습니까?',
    urlRule: 'http/https로 시작된 링크여야 합니다.',
  },
  accountManagement: {
    create_time: '등록시간',
    username: '아이디',
    password: '비밀번호',
    auth: '권한',
    auth1: '최고 관리자',
    auth2: '모임 관리자',
    auth3: '이벤트 관리자',
    auth4: '연재 관리자',
    active: '사용 상태',
    active0: '계정정지',
    active1: '사용중',
    delete: '계정 삭제',
    superManagement: '최고 관리자',
    normalManagement: '일반 관리자',
    sureDeleteAccount: '이 탈퇴 계정을 삭제하시겠습니까?',
    sureDeActive: '이 계정을 정지하시겠습니까?',
    menu: '권한',
  },
  memberManagement: {
    create_time: '등록시간',
    withdraw_date: '탈퇴일시',
    username: '아이디',
    real_name: '이름',
    gender: '성별',
    gender0: '남자',
    gender1: '여자',
    gender2: '기타',
    gender3: '기타',
    phone: '휴대폰 번호',
    favorite_category: '선호 독서 분야',
    favorite_category0: '문학',
    favorite_category1: '인문교양',
    favorite_category2: '역사',
    favorite_category3: '과학',
    favorite_category4: '어린이',
    favorite_category5: '청소년',
    favorite_category6: '그림책',
    favorite_category7: '영어덜트',
    favorite_category8: '만화',
    favorite_category9: '기타',
    is_library: '교육 업계 종사',
    is_publish: '출판계 취업 희망',
    is_policy: '제3자 동의',
    is_email: '이메일 수신동의',
    is_sms: 'SMS 수신동의',
    active: '계정상태',
    active0: '계정정지',
    active1: '사용중',
    yes: '예',
    no: '아니오',
    password: '비밀번호',
    address: '주소',
    address_detail: '상세주소',
    birth: '생년월일',
    passwordRule: '영문,숫자,특수문자 포함 8자 이상 입력해 주세요.',
    member_information: '회원 기본 정보',
    self_hobby: '회원 취향',
    project: '모임 이력',
    project0: '프롤로그',
    project1: '제1장',
    project2: '제2장',
    project3: '없음',
    more: '더보기',
    login_time: '최근 로그인 일시',
    email: '이메일',
    confirmPassword: '비밀번호 확인',
    delivery_request: '배송 요청사항',
    info_edit: '정보 수정',
  },
  send: {
    create_time: '알림 일시',
    to_email: '유저 이메일',
    real_name: '유저 이름',
  },
  serviceCommentList: {
    create_time: '등록시간',
    user_name: '작성자',
    service_name: '서비스 제목',
    active: '공개 여부',
    active0: '비공개',
    active1: '공개',
    content1: '후기 1줄',
    content2: '후기 2줄',
    content3: '후기 3줄',
    sureDeleteComment: '정말 삭제하시겠습니까?',
    is_bold0: '보통',
    is_bold1: '굵게',
  },
  readList: {
    time: '진행기간',
    create_time: '등록시간',
    update_time: '어데이트 시간',
    apply: '신청자 수/모집 인원수',
    apply_num: '신청 수',
    type: '카테고리',
    type0: '클럽창비 멤버십',
    type1: '살롱',
    title: '클럽 제목',
    subtitle: '클럽 부제',
    content: '상세설명',
    cover: '커버 이미지',
    option: '신청 옵션',
    option_desc: '옵션 설명',
    club_changbi_list: '옵션 설정',
    other_title: '참여하기 설명 타이틀',
    other_content: '참여하기 설명 내용',
    price: '가격',
    total_num: '모집 인원수',
    max_purchase_limit: '최대 구매 수량',
    start_time: '시작시간',
    end_time: '마감 시간',
    refund_desc: '환불규정',
    apply_time: '신청 기간',
    apply_start: '신청 시작',
    apply_end: '신청 마감',
    search_tag: '검색 키워드',
    is_recommend: '추천 여부',
    is_recommend0: '비추천',
    is_recommend1: '추천',
    status: '상태',
    status0: '모집중',
    status1: '진행중',
    status2: '진행완료',
    status3: '마감 임박',
    status4: '모집대기',
    status5: '진행대기',
    toReadUseList: '참여 인원 리스트',
    sureDeleteRead: '정말 삭제하시겠습니까?',
    all: '전체',
    read_information: '모임 기본정보',
    read_setting: '모임 설정',
    more: '더보기',
    toTask: '미션',
    toNotice: '공지사항',
    toTopic: '클러버 톡',
    toComment: '후기 작성',
    read_calendar: '신청 전 필독!',
    read_task: '북클럽 안내',
    challenge_rank: '미션 안내',
    challenge_guide: '활동 방법',
    associated_club: '관련 모임',
    book_category: '단행본 항목',
    book_detail_category: '세부 항목',
    book_select: '단행본 선택',
    book_name: '책 제목',
    author_name: '작가명',
    line_copy: '1줄 카피',
    book_category_type0: '선택도서 1',
    book_category_type1: '선택도서 2',
    book_category_type2: '선택도서 3',
    book_category_type3: '선택도서 4',
    book_category_type4: '선택도서 5',
    isbn_code: 'ISBN (영문)',
    isbn_code0: '무',
    isbn_code1: '유',
    isbn_content: 'ISBN (영문)',
    apply_type: '신청방식',
    apply_type0: '자체신청',
    apply_type1: '외부 신청',
    is_deduction: '소득공제',
    is_deduction0: '부',
    is_deduction1: '여',
    pay_type: '유형',
    pay_type0: '일반 이벤트',
    pay_type1: '도서',
    pay_type2: '잡지',
  },
  readNoticeList: {
    create_time: '등록시간',
    publisher_name: '작성자',
    title: '제목',
    content: '내용',
    type: '카테고리',
    type0: '클럽창비 멤버십',
    type1: '살롱',
    active: '상태',
    active0: '비공개',
    active1: '공개',
    order: '정렬 순',
    sureDeleteNotice: '정말 삭제하시겠습니까?',
    is_top: '상단고정',
    is_top1: '예',
    is_top0: '아니오',
  },
  readTaskList: {
    create_time: '등록시간',
    publisher_name: '작성자',
    title: '제목',
    content: '내용',
    end_time: '마감 시간',
    type: '카테고리',
    type0: '클럽창비 멤버십',
    type1: '살롱',
    active: '상태',
    active0: '비공개',
    active1: '공개',
    order: '정렬 순',
    sureDeleteTask: '미션을 삭제하시겠습니까?',
    toAttendanceList: '미션 제출 리스트',
  },
  readCommentList: {
    create_time: '등록시간',
    title: '제목',
    content: '내용',
    commentator: '작성자',
  },
  attendanceList: {
    username: '아이디',
    real_name: '이름',
    task_title: '미션 제목',
    title: '미션 제출 제목',
    content: '미션 제출 내용',
    attach: '첨부파일',
    toCommentList: '댓글 조회',
  },
  readUserList: {
    create_time: '등록시간',
    username: '아이디',
    real_name: '이름',
    phone_num: '휴대폰번호',
    user_address: '주소',
    user_address_code: '우편번호',
    delivery_request: '배송 요청사항',
    club_title: '모임 제목',
    status: '상태',
    status0: '승인대기',
    status1: '승인',
    status2: '취소',
    status3: '환불대기',
    status4: '환불완료',
    refuse_reason: '취소 사유',
    order_pay_amount: '실제 결제 금액',
    count: '수량',
    sureDeleteReadUser: '삭제',
    changeStatus: '상태 수정',
    cancel: '취소',
    allow: '승인',
    refund: '환불',
    all: '전체',
    group_leader: '조장 아이디',
    gender: '성별',
    gender0: '남자',
    gender1: '여자',
    gender2: '기타',
    age: '생년월일',
    allow_print: '수료증 발급',
    book_option: '단행본 옵션',
    book_option_1: '선택도서 1',
    book_option_2: '선택도서 2',
    book_option_3: '선택도서 3',
    book_option_4: '선택도서 4',
    book_option_5: '선택도서 5',
    coupon_title: '쿠폰 사용',
  },
  readTopicList: {
    create_time: '등록시간',
    real_name: '사용자 이름',
    avatar: '프로필 사진',
    content: '내용',
    delete: '상태',
    delete0: '공개중',
    delete1: '삭제완료',
    sureDeleteTopic: '정말 삭제처리 하시겠습니까?',
    is_top: '상단고정',
    is_top1: '예',
    is_top0: '아니오',
    top1: '고정',
    top0: '고정취소',
  },
  attendanceComment: {
    create_time: '등록시간',
    username: '아이디',
    real_name: '이름',
    phone_num: '휴대폰번호',
    content: '내용',
    sureDeleteComment: '정말 삭제처리 하시겠습니까',
  },
  activityList: {
    time: '이벤트 시간',
    create_time: '등록시간',
    update_time: '업데이트 시간',
    apply_num: '신청자 수',
    start_time: '이벤트 시작시간',
    end_time: '이벤트 마감시간',
    // apply_deadline:'이벤트 신청 마감시간',
    apply_time: '신청시간',
    apply_start: '신청 시작시간',
    apply_end: '신청 마감시간',
    title: '이벤트 제목',
    content: '이벤트 내용',
    cover: '커버 이미지',
    type: '이벤트 카테고리',
    type1: '클럽창비(대화)',
    type2: '스페셜 이벤트',
    total_num: '모집 인원수',
    num: '신청자 수/모집 인원수',
    order: '정렬 순',
    sureDeleteActivity: '이벤트를 삭제하시겠습니까?',
    status: '상태',
    status0: '모집 대기',
    status1: '모집중',
    status2: '마감 임박',
    status3: '모집 마감',
    toActivityUserList: '참여인원 리스트',
    active: '상태',
    active0: '비공개',
    active1: '공개',
    apply_type: '신청방식',
    apply_type0: '자체신청',
    apply_type1: '외부 신청',
    external_link: '외부 신청 링크',
    is_pay: '결제 여부',
    is_pay0: '무료',
    is_pay1: '유료',
    subtitle: '이벤트 부제',
    option: '설명 타이틀',
    option_desc: '설명 내용',
    price: '가격',
    max_purchase_limit: '최대 구매 수량',
    refund_desc: '환불 규정',
    is_deduction: '소득공제',
    is_deduction0: '부',
    is_deduction1: '여',
    pay_type: '유형',
    pay_type0: '일반 이벤트',
    pay_type1: '도서',
    pay_type2: '잡지',
    isbn_code: 'ISBN',
    isbn_code0: '무',
    isbn_code1: '유',
    isbn_content: 'ISBN',
  },
  activity_userList: {
    create_time: '등록시간',
    username: '아이디',
    real_name: '이름',
    user_phone: '휴대폰 번호',
    user_address: '주소',
    user_address_code: '우편번호',
    address_detail: '상세주소',
    activity_title: '이벤트 제목',
    activity_type: '이벤트 카테고리',
    activity_type1: '클럽창비(대화)',
    activity_type2: '스페셜 이벤트',
    apply_reason: '신청사유',
    count: '수량',
    pay_amount: '결제금액',
    status: '상태',
    status0: '승인대기',
    status1: '승인',
    status2: '취소',
    status3: '환불대기',
    status4: '환불완료',
    s1: '신청승인',
    s2: '신청거부',
    s3: '환불승인',
    s4: '환불거부',
    sureDeleteUser: '정말 삭제하시겠습니까?',
    refuse_reason: '당첨안내',
    changeStatus: '상태 수정',
    coupon_title: '쿠폰 사용',
  },
  orderList: {
    status: '상태',
    status0: '결제대기',
    status1: '결제완료',
    status2: '결제실패',
    status3: '환불완료',
    status5: '결제예정',
    merchant_uid: '주문번호',
    real_name: '이름',
    title: '제목',
    type: '유형',
    club_type0: '클럽창비 멤버십',
    club_type1: '살롱',
    activity_type1: '클럽창비(대화)',
    activity_type2: '스페셜 이벤트',
    pay_method: '결제방식',
    pay_method0: '신용카드',
    pay_method1: '계좌이체',
    pay_method2: '휴대폰결제',
    pay_method3: '쿠폰',
    pay_method4: '네이버페이',
    price: '원가',
    discount: '할인가',
    count: '수량',
    pay_amount: '결제금액',
    pay_time: '결제 시간',
    username: '유저이름',
    user_gender: '성별',
    user_gender0: '남자',
    user_gender1: '여자',
    user_gender2: '기타',
    user_phone: '휴대폰 번호',
  },
  serialList: {
    update_time: '업데이트 시간',
    title: '작품 제목',
    detail: '상세소개',
    cover: '커버 이미지',
    book_desc: '요약 설명',
    author_name: '작가',
    author_desc: '작가 소개',
    day_of_week: '연재 요일',
    chapter_name: '최신화 제목',
    author_img: '작가 사진',
    is_recommend: '추천 여부',
    recommend0: '비추천',
    recommend1: '추천',
    is_switch_on: 'SWITCH ON',
    switch_on0: '아니오',
    switch_on1: '예',
    status: '상태',
    status0: '연재중',
    status1: '완결',
    active: '공개 여부',
    active0: '비공개',
    active1: '공개',
    sureDeleteSerial: '작품을 삭제하시겠습니까?',
    serial_info: '작품 정보',
    author_info: '작가 정보',
    serial_setting: '작품 설정',
    toChapterList: '연재 리스트 조회하기',
    all: '전체',
    like_num: '좋아요',
    link: '서점 링크',
    tag: '태그',
  },
  chapterList: {
    create_time: '등록시간',
    update_time: '업데이트 시간',
    title: '연재 제목',
    number: '연재 화수',
    content: '내용',
    active: '공개 여부',
    active0: '비공개',
    active1: '공개',
    sureDeleteChapter: '정말 삭제하시겠습니까?',
    show_time: '예약 공개',
    is_free: '비회원 공개여부',
    is_free1: '예',
    is_free0: '아니오',
  },
  couponList: {
    type: '카테고리',
    type0: '클럽창비 멤버십',
    type1: '살롱',
    type2: '클럽창비(대화)',
    type3: '스페셜 이벤트',
    time: '사용시간',
    create_time: '등록시간',
    update_time: '업데이트 시간',
    start_time: '시작시간',
    end_time: '마감 시간',
    redeem_code: '쿠폰 등록 코드',
    redeem_num: '등록 완료수',
    title: '제목',
    totla_num: '등록 가능수',
    amount: '쿠폰 금액',
    exchange: '등록 완료수/등록 가능수',
    status: '상태',
    status0: '사용불가',
    status1: '사용가능',
    status2: '기한만료',
    sureDeleteCoupon: '정말 삭제하시겠습니까?',
    user_name: '아이디',
    real_name: '이름',
    user_phone: '휴대폰 번호',
    user_gender: '성별',
    user_gender0: '남자',
    user_gender1: '여자',
    user_gender2: '기타',
    service_info: '서비스 정보',
    use_time: '사용시간',
    toCouponUseList: '쿠폰 사용 리스트 조회하기',
    setMember: '대상 회원',
    setMemberBtn: '대상 회원 설정',
    searchPlaceholder: '이름 혹은 아이디를 입력해 주세요.',
    searchMember: '회원ID, 아이디, 이름 혹은 휴대폰 번호를 입력해 주세요.',
  },
  FAQ: {
    sureDeleteFAQ: '정말 삭제하시겠습니까?',
    tag: '질문 유형',
    order: '정렬 순',
    question: '질문',
    answer: '답변',
    active: '공개 여부',
    active1: '공개',
    active0: '비공개',
  },
  QA: {
    create_time: '등록시간',
    update_time: '업데이트 시간',
    title: '제목',
    question: '질문',
    status: '상태',
    status0: '답변대기',
    status1: '답변완료',
    answer: '답변',
    sureDeleteQA: '정말 삭제하시겠습니까?',
    username: '아이디',
    real_name: '이름',
    category: '질문 구분',
    category0: '멤버십 가입',
    category1: '살롱(독서모임)',
    category2: '사유(뉴스레터)',
    category3: '이벤트',
    category4: '기타',
    category5: '대화(강연)',
    category6: '배송 문의',
    category7: '회원 정보',
  },
  notice: {
    create_time: '등록시간',
    update_time: '업데이트 시간',
    title: '제목',
    subtitle: '부제',
    content: '내용',
    order: '정렬 순',
    active: '공개 여부',
    active0: '비공개',
    active1: '공개',
    sureDeleteNotice: '정말 삭제하시겠습니까?',
    is_home: '홈 화면',
    is_home0: '일반',
    is_home1: '홈 화면',
    cover: '이미지',
  },
  setting: {
    title: '제목',
  },
  memberAttendance: {
    club_title: '모임 제목',
    task_title: '미션 제목',
    task_content: '미션 내용',
    title: '미션 제출 제목',
    content: '미션 제출 내용',
    attach: '첨부파일 링크',
    file_name: '첨부파일',
    create_time: '제출시간',
  },
  memberComment: {
    club_title: '모임 제목',
    task_title: '미션 제목',
    task_content: '미션 내용',
    attendance_title: '미션 제출 제목',
    attendance_content: '미션 제출 내용',
    content: '댓글 내용',
    create_time: '댓글 시간',
  },
  memberDiscuss: {
    club_title: '모임 제목',
    content: '클러버 톡 내용',
    create_time: '게시 시간',
  },
  sureDelete: '정말 삭제하시겠습니까?',
  day1: '월',
  day2: '화',
  day3: '수',
  day4: '목',
  day5: '금',
  select_date: '날짜 선택',
  please_select: '선택해 주세요.',
  start_date: '시작시간',
  end_date: '마감시간',
  to: '~',
  search: '키워드를 입력해 주세요.',
  exit: '로그아웃',
  in: '로그인',
  backstageName: 'switch_admin',
  loginSuccess: '로그인 환영합니다.',
  signOutSuccess: '로그아웃 되었습니다.',
  changeSuccess: '수정되었습니다.',
  inputAccount: '아이디를 입력해 주세요.',
  inputPassword: '비밀번호를 입력해 주세요.',
  min6: '최소 6자 입력해 주세요.',
  min3: '최소 3자 입력해 주세요.',
  operation: '관리',
  search_zh: '검색',
  back: '이전으로',
  tips: '알림',
  outExe: 'excel 출력',
  addMember: '추가',
  addMemberModalTitle: '대상 회원 추가',
  addAllMember: '전체 회원지급',
  sort: '정렬',
  all: '전체',
  btnTip: {
    submit: '확인',
    check: '조회',
    edit: '수정',
    delete: '삭제',
    add: '추가',
    close: '닫기',
    cancel: '취소',
    resetPW: '비번 수정',
    refuse: '취소',
    reset: '새로고침',
    save: '저장',
  },
};
export default { ...ko, ...koLocale };
